class FoundationCmsPersonalization {
    init() {

        var tracking = new BlockTracking();
        tracking.init();
    }
}